import { z } from 'zod';
/**
 * Курсорная пагинация (ТЗ §8.1). Offset не используем: на растущих таблицах
 * телеметрии он даёт пропуски и дубли между страницами.
 */
export const paginationQuerySchema = z.object({
    limit: z.coerce.number().int().min(1).max(200).default(50),
    cursor: z.string().min(1).optional(),
});
export function paginatedSchema(item) {
    return z.object({
        items: z.array(item),
        nextCursor: z.string().nullable(),
    });
}
//# sourceMappingURL=pagination.js.map